<template>
    <div>
        <v-form ref="entryForm" @submit.prevent="saveContact()" v-model="isFormValid">

            <div style="margin-top: 2%; display: flex; justify-content: space-between; align-items: center;">
                <h3 v-if="!createNew">Contact Info {{ contact.OD_PatNum ? ': Patient #' + contact.OD_PatNum : '' }}</h3>
                <h3 v-else>Create New Contact</h3>

                <v-btn icon size="30">
                    <v-icon color="indigo-darken-3" size="25" style="margin: 10%;">mdi-dots-vertical-circle-outline</v-icon>
                    <v-menu activator="parent">
                        <v-list style="width: 180px;">
                             <v-list-item @click="createNewContact()">
                                <v-icon color="green" size="25" style="margin: 10%;">mdi-account-plus</v-icon> Create New
                             </v-list-item>
                             <v-list-item @click="openContactImport">
                                <v-icon color="primary" size="25" style="margin: 10%;">mdi-file-download-outline</v-icon> import
                             </v-list-item>
                        </v-list>
                    </v-menu>
                    <v-tooltip activator="parent" location="bottom">Create New Contact</v-tooltip>
                </v-btn>
            </div>

            <div style="display: flex; margin-top: 25px;">
                <div style="flex-direction: column;width:50%">
                    <v-text-field ref="fname_field" style="width: 100%" label="First Name (Required)"
                        v-model="first_name" :rules="RULES.REQUIRED_FIELD('First Name')" variant="outlined" :disabled="isDisabled"
                        dense></v-text-field>
                    <v-text-field style="width: 200px" label="Phone Number" v-model="ph1" :rules="RULES.PHONE_NUMBER"
                        variant="outlined" dense :disabled="isDisabled" ref="ph1_field"></v-text-field>

                    <v-text-field style="width: 200px" label="Home Number" v-model="ph2" :rules="RULES.PHONE_NUMBER"
                        variant="outlined" dense :disabled="isDisabled" ref="ph3_field"></v-text-field>

                    <v-text-field style="width: 200px" label="Work Number" v-model="ph3" :rules="RULES.PHONE_NUMBER"
                        variant="outlined" dense :disabled="isDisabled" ref="ph2_field"></v-text-field>

                    <v-text-field style="width: 200px" label="Address Line 1" v-model="address_line_1"
                        variant="outlined" dense :disabled="isDisabled"></v-text-field>
                    <v-text-field style="width: 200px" label="City" v-model="city" variant="outlined" dense
                        :disabled="isDisabled" ref="city_field" :rules="RULES.CITY_NAME"></v-text-field>
                    <v-text-field style="width: 200px" label="Zip Code" v-model="zip" :rules="RULES.ZIP_CODE"
                        variant="outlined" dense :disabled="isDisabled"></v-text-field>
                   

                </div>
                <div style="flex-direction: column; margin-left: 50px;width:50%">
                    <v-text-field style="width: 100%" label="Last Name (Required)" v-model="last_name"
                        :rules="RULES.REQUIRED_FIELD('Last Name')" variant="outlined" dense :disabled="isDisabled"
                        ref="lname_field"></v-text-field>
                    <v-checkbox v-model="textable1" label="Is Textable" :disabled="isDisabled"></v-checkbox>

                    <v-checkbox v-model="textable2" label="Is Textable" :disabled="isDisabled"></v-checkbox>
                    <v-checkbox v-model="textable3" label="Is Textable" :disabled="isDisabled"></v-checkbox>

                    <v-text-field style="width: 200px" label="Address Line 2" v-model="address_line_2"
                        variant="outlined" :disabled="isDisabled" dense></v-text-field>

                    <v-select style="width: 200px" label="State" :items="states" v-model="state" variant="outlined"
                        :disabled="isDisabled" dense></v-select>
                    <v-text-field style="width: 200px" label="Email Address" v-model="email" :rules="RULES.EMAIL"
                        variant="outlined" dense ref="email_field" :disabled="isDisabled"></v-text-field>

                </div>
            </div>

            <h3 style="margin-top: 20px">Personal Info</h3>
            <div style="display: flex; margin-top: 25px;">
                <div style="flex-direction: column">
                    <label>
                        Date of Birth
                        <div class="justify-center" style="text-align: center; margin-bottom: 30px">
                            <input style="width: 200px" type="date" v-model="birth_date" :disabled="isDisabled">
                        </div>
                    </label>
                    <v-select style="width: 200px" label="Language" :items="language_list" v-model="language"
                        variant="outlined" :disabled="isDisabled" dense></v-select>
                </div>
                <div style="flex-direction: column; margin-left: 40px;">
                    <v-select style="width: 200px" label="Marital Status"
                        :items="['Single', 'Married', 'Child', 'Widowed', 'Divorced']" v-model="martial_status"
                        variant="outlined" :disabled="isDisabled" dense></v-select>
                    <v-select style="width: 200px" label="Gender" :items="['Female', 'Male', 'Unknown']"
                        v-model="gender" variant="outlined" :disabled="isDisabled" dense></v-select>
                    <v-select style="width: 200px; margin-top: 20px" label="Preferred Contact Method"
                        :items="['None', 'Do Not Call', 'Home Phone', 'Work Phone', 'Wireless Phone', 'Email', 'Mail', 'Text Message', 'See Notes']"
                        v-model="preffered_contact" variant="outlined" :disabled="isDisabled" dense></v-select>
                </div>
            </div>

            <div style="display: flex; margin-top: 30px; justify-content: space-around" v-if="!checkContactID() || createNew">
                <v-btn color="primary" @click="setPatientFields()">{{"Re-store  "}} <v-icon size="15">mdi-restore</v-icon></v-btn>
                <v-btn color="success" type="submit" :disabled="!isFormValid" >{{ (createNew ? "Create " : "Save ") }}<v-icon size="15" >mdi-content-save</v-icon></v-btn>
            </div>
        </v-form>
    </div>
</template>

<script>
import { mapState } from "vuex";
import EventBus from "@/eventBus";
import crmService from "@/services/crmService";
import MiscService from '@/services/miscService';
import { phoneFormat, states } from "@/util/util";
import { languages } from "@/util/languages";
import { parseISO,format } from 'date-fns';
import { ALERT } from "../../../constants/alert";
import { RULES } from "../../../constants/validationRules";
export default
    {
        name: 'ContactDetails',
        data() {
            return {
                isFormValid: false,
                first_name: "",
                last_name: "",
                gender: "",
                ph1: "",
                ph2: "",
                ph3: "",
                textable1: false,
                textable2: false,
                textable3: false,
                address_line_1: "",
                address_line_2: "",
                city: "",
                zip: "",
                state: "",
                states,
                email: "",
                date_menu: false,
                birth_date: "",
                martial_status: "",
                preffered_contact: "",
                language: "",
                languages,
                language_list: [],
                contact_json: { 'None': 'None', 'Do Not Call': 'DoNotCall', 'Home Phone': 'HmPhone', 'Work Phone': 'WkPhone', 'Wireless Phone': 'WirelessPh', 'Email': 'Email', 'Mail': 'Mail', 'Text Message': 'TextMessage', 'See Notes': 'SeeNotes' },
                createNew : false,
                RULES
            }
        },
        watch: {
            contact() {
                this.setPatientFields();
            }
        },
        props: { contact: { type: Object, default: null, required: true } },
        computed: {
            ...mapState(['isPanelVisible']),
            isDisabled() {
                return ((this.contact && this.contact.OD_PatNum) && !this.createNew ? true : false);
            }
        },
        methods: {
            checkContactID() {
                return (this.contact && this.contact.OD_PatNum);
            },
            async saveContact() {
                this.ph1 = this.checkPhoneInput(this.ph1);
                this.ph2 = this.checkPhoneInput(this.ph2);
                this.ph3 = this.checkPhoneInput(this.ph3);

                const phonePattern = /^\d{0,10}$/

                if (!!this.first_name && !!this.last_name && (this.ph1 || phonePattern.test(this.ph1)) && (this.ph2 || phonePattern.test(this.ph2)) && (this.ph3 || phonePattern.test(this.ph3))) {
                    const l = this.languages.find(a => a.name == this.language);
                    let lang = (l ? l.iso6392B : null);
                    const data = {
                        first_name: this.first_name, last_name: this.last_name, ph2: this.ph2, ph3: this.ph3, ph1: this.ph1,
                        email: this.email, textable1: this.textable1, textable2: this.textable2, textable3: this.textable3, Gender: this.gender, Position: this.martial_status, Birthdate: this.birth_date ? parseISO(this.birth_date).getTime().toString() : null, SSN: '',
                        Address: this.address_line_1, Address2: this.address_line_2, City: this.city, State: this.state, Zip: this.zip,
                        Email: this.email, PreferContactMethod: this.contact_json[this.preffered_contact], Language: lang
                    };
                   
                    if (this.checkIfCreate() || this.createNew) {
                        try {
                            let res = await crmService.addContact(data);
                            console.log("New Contact Details "+ res);
                            this.createNew = false;
                           if (res.status == 200) {
                                EventBus.$emit("alert", {
                                    message: "Contact Created Successfully",
                                    type: ALERT.SUCCESS,
                                });
                            }
                            EventBus.$emit("close-right-panel");
                        } catch (error) {
                            console.log(error);
                            EventBus.$emit("alert", {
                                message: "Failed To Create Contact",
                                type: ALERT.ERROR,
                            });
                        } 
                    } else {
                        try {
                            let result = await crmService.updateContact(this.contact.contact_id, data);
                            if (result.data.status == "failure") {
                                EventBus.$emit("alert", {
                                    message: "Failed To Update Contact",
                                    type: ALERT.ERROR,
                                });
                            

                            } else if (result.data.status == "success") {
                                EventBus.$emit("alert", {
                                    message: "Contact Updated Successfully",
                                    type: ALERT.SUCCESS,
                                });
                                EventBus.$emit("close-right-panel");
                            }
                        } catch (error) {
                            console.error(error);
                            EventBus.$emit("alert", {
                                message: "Failed To Update Contact",
                                type: ALERT.ERROR,
                            });
                        }
                    }
                } else {
                    EventBus.$emit("alert", {
                        message: "Please fill in all required fields",
                        type: ALERT.ERROR,
                    });
                }
                this.isFormValid = false;
            },
            async setPatientFields() {
              try {
                if (!this.contact.contact_id){ return }
                let res = await MiscService.getContact(this.contact.contact_id);
                const contact = res.data;
                this.createNew = false;
                this.clearFields();
                if (!contact) {
                    return;
                } else {
                    this.first_name = contact.first_name;
                    this.last_name = contact.last_name;
                    this.ph1 = (contact.ph1 == "" ? "" : phoneFormat(this.contact.ph1));
                    this.ph2 = (contact.ph2 == "" ? "" : phoneFormat(this.contact.ph2));
                    this.ph3 = (contact.ph3 == "" ? "" : phoneFormat(this.contact.ph3));
                    this.textable1 = contact.textable1;
                    this.textable2 = contact.textable2;
                    this.textable3 = contact.textable3;
                    this.email = contact.email;



                    this.address_line_1 = contact.Address;
                    this.address_line_2 = contact.Address2;
                    this.city = contact.city;
                    this.state = contact.state;
                    this.zip = contact.zip;
                    this.gender = contact.gender;
                    this.birth_date = '';
                    if(contact.Birthdate){
                        const date = new Date(contact.Birthdate);
                        this.birth_date = format(date, 'yyyy-MM-dd');
                    }
                    this.martial_status = contact.Position;
                    if (contact.Language !== "") {
                        this.language = this.languages.find(a => a.iso6392B == contact.Language)?.name || 'English';
                    }
                    for (const key of Object.keys(this.contact_json)) {
                        if (this.contact_json[key] == contact.PreferContactMethod) {
                            this.preffered_contact = key;
                            break;
                        }
                    }

                }
            } catch (error) {
                console.log(error);
            }
            },
            checkIfCreate() {
                return !this.contact.contact_id;
            },
            checkPhoneInput(phone) {
                if (!phone) return "";
                phone = phone.replace(/\D/g, '');
                // if(phone.length == 10) phone = "1" + phone;

                return phone;
            },
            clearFields() {
                this.first_name = "";
                this.last_name = "";
                this.gender = "";
                this.ph1 = "";
                this.ph2 = "";
                this.ph3 = "";
                this.textable1 = false;
                this.textable2 = false;
                this.textable3 = false;
                this.address_line_1 = "";
                this.address_line_2 = "";
                this.city = "";
                this.zip = "";
                this.state = "";
                this.email = "";
                this.date_menu = false;
                this.birth_date = "";
                this.martial_status = "";
                this.preffered_contact = "";
                this.language = "";
            }, 
            phoneFormat,
            createNewContact(){
                this.clearFields();
                this.createNew = true;
            },
            openContactImport(){
                this.$router.push({ path: "/contactsImport" });
            }
        },
        created() {
            this.setPatientFields();
            this.language_list = this.languages.map(a => a.name);
        }

    }

</script>

<style></style>